import {
  Injectable,
  ComponentFactoryResolver,
  ViewContainerRef,
  ComponentRef,
  Component
} from "@angular/core";
import { TabItem } from '../profile-tab.directory';
import { TabComponent } from '../components/tab-component';

@Injectable()
export class TabTemplateService {
  rootViewContainer: ViewContainerRef;
  currentComponentRef: ComponentRef<Component>;

  constructor(private factoryResolver: ComponentFactoryResolver) { }

  setRootViewContainerRef(viewContainerRef: ViewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }

  public addDynamicComponentTemplates(tabs: TabItem[]) {
    tabs.forEach(c => {
      const factory = this.factoryResolver.resolveComponentFactory(c.component);
      const component = factory.create(this.rootViewContainer.parentInjector);
      this.rootViewContainer.insert(component.hostView);
    });
  }

  public addDynamicComponentTemplate(tab: TabItem) {
    const factory = this.factoryResolver.resolveComponentFactory(tab.component);
    const componentRef = this.rootViewContainer.createComponent(factory);
    (<TabComponent>componentRef.instance).data = tab.data;
    this.currentComponentRef = componentRef;
  }

  public isDirty() {
    if (this.currentComponentRef) {
      return (<TabComponent>this.currentComponentRef.instance).isDirty();
    }
  }

  clearRootViewContainerRef() {
    if (this.rootViewContainer) {
      this.rootViewContainer.clear();
    }
  }
}
